<script setup>
import { computed } from 'vue';

const props = defineProps({
  config: {
    type: Object,
    default: () => ({}),
  },
});

const welcomeTextStyle = computed(() => {
  const color = props.config.fontColor;
  return color ? { color } : {};
});

const stripHtml = html =>
  (html || '')
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/g, ' ')
    .trim();

const displayTitle = computed(() => {
  const text = props.config.welcomeHeading?.trim();
  if (text) return text;
  return props.config.welcomeHeadingPlaceholder || '';
});

const displayTagline = computed(() => {
  const text = stripHtml(props.config.welcomeTagline);
  if (text) {
    return stripHtml(props.config.welcomeTagline).replace(/\s+/g, ' ');
  }
  return (props.config.welcomeTaglinePlaceholder || '').replace(/\s+/g, ' ');
});

const isPlaceholderTitle = computed(() => !props.config.welcomeHeading?.trim());
</script>

<template>
  <header
    class="flex-shrink-0 rounded-t-lg bg-n-background px-5 py-4 dark:bg-n-solid-1"
  >
    <div class="flex items-center justify-start gap-3">
      <img
        v-if="config.logo"
        :src="config.logo"
        class="logo h-8 w-8 shrink-0 rounded-full object-cover"
        alt=""
      />
      <div class="flex min-w-0 flex-col gap-1">
        <div class="flex items-center gap-1">
          <span
            class="truncate text-lg font-semibold leading-5"
            :class="isPlaceholderTitle ? 'text-n-slate-11' : 'text-n-slate-12'"
            :style="welcomeTextStyle"
          >
            {{ displayTitle }}
          </span>
          <div
            v-if="config.isOnline"
            class="h-2 w-2 shrink-0 rounded-full bg-n-teal-10"
          />
        </div>
        <span
          class="block truncate text-xs leading-3 text-n-slate-11"
          :style="welcomeTextStyle"
        >
          {{ displayTagline }}
        </span>
      </div>
    </div>
  </header>
</template>
